import {lazy, Suspense} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import IconInfo from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'
import TitleBasic from '@adv-mt/mt-title-basic'

const MoleculeModal = lazy(() => import(/* webpackChunkName: "ModalDisclaimer" */ '@s-ui/react-molecule-modal'))

// eslint-disable-next-line react/prop-types
export const ModalDisclaimerIcon = ({onClick, children, label}) => {
  return (
    <div className="mt-ModalDisclaimer-title">
      {children}
      <IconInfo
        {...(label ? {'aria-label': label} : {})}
        aria-haspopup="dialog"
        as="button"
        onClick={onClick}
        size={ATOM_ICON_SIZES.medium}
      />
    </div>
  )
}

function ModalDisclaimer({open = false, onClose, title, subtitle, text = ''}) {
  if (!open) return <></>

  return (
    <Suspense fallback={<></>}>
      <MoleculeModal
        isOpen={open}
        header={<TitleBasic as="h2" size="s" title={title} />}
        closeOnOutsideClick
        closeOnEscKeyDown
        iconClose={<IconClose color="currentColor" size="medium" />}
        onClose={onClose}
      >
        <>
          <TitleBasic as="h4" size="xxs" title={subtitle} />
          <p className="mt-VehicleConfigurator-modalContent">{htmlStringToReactElement(text)}</p>
        </>
      </MoleculeModal>
    </Suspense>
  )
}

ModalDisclaimer.displayName = 'ModalDisclaimer'
ModalDisclaimer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string
}

export default ModalDisclaimer
